import { useStoreUI } from '@/Store/storeUI';

export function defineUIContext() {
    if (useStoreUI().isSelectedModel) return 'ctrl';
    if (useStoreUI().leftSidebarTab === 'project') {
        return 'project';
    } else if (useStoreUI().leftSidebarTab === 'case') {
        if (useStoreUI().caseMenuCategory.includes('template')) {
            return 'presets';
        } else {
            return 'items';
        }
    }
}
